export const Equipment =() => [
    {
      name: 'client_cust_id',
      col: 8,
      lable: 'CUSTOMER',
      type: 'dropdown',
      value: [],
      rules: [
        {
          required: true,
          message: 'Please Select Customer!',
          whitespace: true,
        },
      ],
    },
    {
      name: 'driver_name',
      lable: 'DRIVER',
      col: 8,
    },
    

    {
      name: 'trucking_carrier',
      lable: 'TRUCK CARRIER',
      col: 8,
    },
    {
      name:'custom1'
    },
    {
      name: 'equipment_no',
      lable: 'EQUIPMENT NUMBER',
      col: 8,
      type: 'autocomplete',
      value: [],
      rules: [
        {
          required: true,
          message: 'Please Enter equipment number!',
          whitespace: true,
        },
      ],
    },
    {
      name: 'quantity',
      lable: 'QUANTITY',
      type:'number',
      col: 4,
    },
    
    {
      name: 'generator',
      lable: 'FROM/GENERATOR',
      col: 6,
      rules: [
        {
          required: true,
          message: 'Please Enter form generator!',
          whitespace: true,
        },
      ],
    },
    {
      name: 'last_known',
      lable: 'HAZARDOUS',
      type: 'radio',
      col: 6,
      value: [
        { value: 'nonhaz', displayValue: 'No' },
        { value: 'haz', displayValue: 'Yes' },
      ],
      rules: [
        {
          required: true,
          message: 'Please Select Hazardous Category!',
          whitespace: true,
        },
      ],
    },
    {
      name: 'hazardous',
      lable: 'LAST CONTAINED',
      disabled: true,
      col: 6,
      rules: [
        {
          message: 'Please Enter Last Contained!',
          whitespace: true,
        },
      ],
    },
    
    {
      name: 'job_site',
      lable: 'JOBSITE',
      col: 6,
    },
    {
      name:'custom2'
    },
    
    {
      name: 'po_id',
      lable: 'PO#',
      type: 'dropdown',
      value: [],
      col: 12,
      rules: [
        {
          required: false,
          message: 'Please Enter po!',
          whitespace: true,
        },
      ],
    },
    {
      name: 'location_id',
      col: 12,
      lable: 'YARD NAME',
      type: 'dropdown',
      value: [],
      rules: [
        {
          required: true,
          message: 'Please Select yard name!',
          whitespace: true,
        },
      ],
    },
  ];

  export const confirmation =() => [
    {
      name: 'email',
      lable: 'PROVIDE DROP OFF CONFIRMATION',
      placeholder: 'EMAIL',
    },
    // {
    //   name: 'number',
    //   lable: 'OR',
    //   placeholder: 'PHONE',
    // },
  ];
  export const estimate =() =>( {
    name: 'estimate',
    col: 24,
    lable: 'ESTIMATE',
    rules: [
      {
        required: true,
        message: 'Please Enter estimate!',
      },
      { type: 'number' },
      {
        pattern: /^(0*[1-9][0-9]*(\.[0-9]+)?|0+\.[0-9]*[1-9][0-9]*)$/,
        message: 'Estimate value should be greater than 0 number',
      },
    ],
  })
  